import { processSilentRenew } from 'redux-oidc';

export const SilentRenew = () => {
  processSilentRenew();
  return (
    <div aria-live='polite' aria-busy='true'>
      Loading...
    </div>
  );
};
